<template>
  <CheckDetail :info="info" />
</template>

<script>
import CheckDetail from '@/components/check-detail';

export default {
  props: {
    testId: String,
    deviceType: String
  },
  components: { CheckDetail },
  computed: {
    info() {
      return {
        id: this.testId,
        deviceType: this.deviceType
      };
    }
  }
};
</script>
